import React, { useContext, useEffect } from "react";
import { FireBaseContext } from "../../Context/FireBase";


function TopSubscribersReport() {
  const { EventRefrence, SubscribersRefrence } = useContext(FireBaseContext);

  const getEventsData = () => {
    
  };

  useEffect(() => {
    getEventsData();
  }, []);

  return (
    <div className="max-w-screen-xl mx-auto">
      {/* <ToastContainer /> */}
      <h2 className="mb-4">Top 5 Subscribers Report</h2>

      <div className="bg-white p-3 rounded-md ">
        <div className="overflow-x-auto mt-4 mb-6 ">
          <table className="min-w-full bg-white  rounded-lg  text-center ">
            <thead className=" text-black  text-lg border-b border-gray-200">
              <tr>
                <th className="w-1/6 py-3 px-4">Subscriber Name</th>
                <th className="w-1/6 py-3 px-4">Email</th>
                <th className="w-1/6 py-3 px-4">Total Events</th>
              </tr>
            </thead>
            <tbody className=""></tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default TopSubscribersReport;
